import $ from 'jquery'
import slick from 'slick-carousel'

export default class Carousel {
  constructor() {
    $('.carousel').slick({
      infinite: true,
      autoplay: true,
      fade: true,
      mobileFirst: true,
      arrows: false,
      speed: 2500
    });
  }
}
